import "core-js/modules/es.array.find-index";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SvgIcons from '@tencent/vft-ui/src/SvgIcons/SvgIcons.vue';
import UsePop from '../Pop/UsePop/UsePop.vue';
export default {
  components: {
    SvgIcons: SvgIcons,
    UsePop: UsePop
  },
  computed: {
    curItem: function curItem() {
      return this.setting.演出场次[this.index];
    },
    // 当前用户选中的礼包是否有票
    hasTicket: function hasTicket() {
      return this.hasTickets[this.curItem.pid];
    },
    // 计算6个演出场次中第一个有票的场次
    hasTicketIndex: function hasTicketIndex() {
      var _this = this;

      return this.setting.演出场次.findIndex(function (v) {
        return _this.hasTickets[v.pid];
      });
    }
  },
  watch: {
    // 监听变化
    hasTicketIndex: function hasTicketIndex(v) {
      if (v === -1) return;
      this.index = v;
      this.scroll(v);
    }
  },
  data: function data() {
    return {
      index: 0,
      showPop: false
    };
  },
  methods: {
    // 设置支付面板信息并拉起支付
    selectGift: function selectGift(url) {
      if (this.hasTicket) {
        this.openUrl(url || this.setting.福利特权.礼包跳转链接);
      } else {
        this.$store.dispatch('setSelectPayInfo', this.curItem);
        this.openPay();
      }
    },
    scroll: function scroll(index) {
      var _this2 = this;

      this.$nextTick(function () {
        var list = _this2.$refs.list;
        var item = list.querySelector('.item');
        list.scrollLeft = item.clientWidth * index + 1;
      });
    }
  }
};